export default {
    auth: [
        {
            icon: 'mdi-home-outline',
            name: 'الصفحة الرئيسية',
            to: {name: 'home'}
        },
        /* {
            icon: 'mdi-text-box-outline',
            name: 'سياسة الخصوصية',
            to: {name: 'privacy-policy'}
        }, */
        {
            icon: 'mdi-help',
            name: 'المساعدة',
            to: {name: 'help'}
        }
    ],
    guest: [
        {
            icon: 'mdi-home-outline',
            name: 'الصفحة الرئيسية',
            to: {name: 'welcome'}
        },
        {
            icon: 'mdi-account-plus-outline',
            name: 'التسجيل',
            to: {name: 'register'}
        },
        {
            icon: 'mdi-login-variant',
            name: 'تسجيل الدخول',
            to: {name: 'login'}
        },
        /* {
            icon: 'mdi-text-box-outline',
            name: 'سياسة الخصوصية',
            to: {name: 'privacy-policy'}
        }, */
        {
            icon: 'mdi-help',
            name: 'المساعدة',
            to: {name: 'help'}
        }
    ]
}